import React from 'react'
import cx from 'classnames'
import { Link } from '../link'
import { CoverImage } from '../image'
import { Arrow } from '../icons'
import styles from './case-study-card.module.scss'

export default function CaseStudyCard({
  image,
  title,
  company,
  description,
  tags,
  url,
  appearance = 'default',
}) {
  return (
    <Link
      to={url}
      className={cx(styles.link, {
        [styles.compact]: appearance === 'compact',
      })}
    >
      <header>
        <CoverImage ratio={277 / 334} {...image} />
        <h3 className="type-dfbi-card-title">
          <span>{title}</span>
        </h3>
        <p className="type-dfbi-card-company">{company}</p>
      </header>
      <div className="child-my-0">
        <p className="type-dfbi-card-description">{description}</p>
      </div>
      <footer>
        <p className="type-dfbi-label-sm">{tags}</p>
        <Arrow />
      </footer>
    </Link>
  )
}
